export default __webpack_public_path__ + "static/media/position.05f7e621.svg";